import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { parseString } from 'xml2js';

import { PlessHttp } from './http/pless-http.service';
import { HttpHeaders } from '@angular/common/http';

/**
 * messages.xmlからデータを取得するサービス
 *
 * @export
 * @class GetMessagesService
 */
@Injectable()
export class GetMessagesService {

    constructor(protected plessHttp: PlessHttp) { }

    private filePath = 'app/messages.xml';
    private messageList: Array<any> = null;
    private messageId;
    private func;

    /**
     * 渡されたmessageIdとfuncを一時退避し、
     * messages.xmlから既にデータを取得しているか判定し、
     * 既に取得している場合は該当メッセージ取得の取得、
     * 未だ取得していない場合は、messages.xmlからのデータ取得処理を呼び出す
     *
     * @param {string} messageId メッセージID
     * @param {Function} func 後続処理
     * @memberof GetMessagesService
     */
    execute(messageId: string, func: Function) {
        this.messageId = messageId;
        this.func = func;

        // 既にmessages.xmlから値を取得しているか判定
        if (this.messageList === null) {
            const response = this.plessHttp.get(this.filePath, 
                { headers: new HttpHeaders(), responseType: 'text', withCredentials: true });
            this.setMessageList(response);
        } else {
            this.getMessage();
        }
    }

    /**
     * messages.xmlからデータを取得し、
     * xml形式で解析後、変数へ格納する。
     *
     * @param {*} httpresponse messages.xml取得戻り値
     * @memberof GetMessagesService
     */
    setMessageList(httpresponse: any) {
        httpresponse.subscribe(
            response => {
                // xml解析
                parseString(response.body, (err, result) => {
                    if (err) {
                        // エラーの場合は、後続処理への引数をnullで設定
                        this.func(null);
                    } else {
                        // messages.xmlの戻りを設定し、
                        // 該当メッセージ取得処理を実行
                        this.messageList = result.Messages.Message;
                        this.getMessage();
                    }
                });
            },
            error => {
                // エラーの場合は、後続処理への引数をnullで設定
                this.func(null);
            }
        );
    }

    /**
     * 渡されてきたメッセージIDと一致するメッセージ情報を探し、
     * 該当するものがある場合は、戻り値へ設定後後続処理を呼び出す
     * 該当するものがない場合は、nullで後続処理を呼び出す
     *
     * @memberof GetMessagesService
     */
    getMessage() {
        let resultMessage = null;
        Object.keys(this.messageList).forEach((key) => {
            if (this.messageList[key].ID[0] === this.messageId) {
                resultMessage = this.messageList[key];
            }
        });
        this.func(resultMessage);
    }
}
